export default __webpack_public_path__ + "static/media/ARM.6efdac6a.png";